<template>
  <div class="EvaluationList">
    <div class="header">
      <div class="header-empname">{{ pageConfig.emp_name }}</div>
    </div>
    <div class="wrapper">
      <van-empty
        v-if="pageConfig.evaluationList.length == 0"
        description="未找到任何考核记录"
      />
      <div class="vant-table" v-else>
        <table cellspacing="0" class="table">
          <tr>
            <th class="th" style="width:100px">考核名称</th>
            <th class="th" style="width:80px">考核类型</th>
            <th class="th" style="width:80px">考核年度</th>
            <th class="th" style="width:80px">考核等级</th>
          </tr>
          <tr v-for="row in pageConfig.evaluationList" :key="row.id">
            <td align="left">
              {{ row.evaluation_name }}
            </td>
            <td align="left">
              {{ row.evaluation_type }}
            </td>
            <td align="right">
              {{ row.evaluation_year }}
            </td>
            <td align="left">
              {{ row.level }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { CallIPaasService } from '@/api/mobile.js'
import {
  GetPayroll,
  getHaveSecurityCode,
  setSecurityCode,
  verifySecurityCode,
} from '@/api/ehrSal.js'
import { Toast } from 'vant'
import ChangeTitle from "@/utils/changeTitle";

import { onMounted, reactive } from 'vue'
export default {
  setup() {
    const pageConfig = reactive({
      emp_name:'',//
      evaluationList: [], //考核记录列表
    })
    //内置函数
    const methods = {
      //初始化
      init: function () {      
        ChangeTitle.setTitle('等第查询')
        pageConfig.emp_name = localStorage.getItem("emp_code")   +'-'+   localStorage.getItem("emp_name")   
        //获取考核列表
        methods.getEvaluationList()
      },
      //获取考核列表
      getEvaluationList: function () {
        let param = {}
        CallIPaasService(param, 'pis1005').then((res) => {
          if (res.code != 200) {
            return
          }
          pageConfig.evaluationList = res.data
        })
        // GetPayroll(param).then(res => {
        //   if (res.code != 200) {
        //     Toast(res.msg)
        //     return
        //   }

        // })
      },
    }
    onMounted(() => {
      methods.init()
    })
    return {
      methods,
      pageConfig,
    }
  },
}
</script>
<style lang="scss" scoped>
.EvaluationList{
  padding: 0 5px;
  .header {
    .header-empname {
      background-color: #fff;
      font-size: 12px;
      line-height: 30px;
      text-align: center;
    }
  }
  .wrapper{
     .vant-table {
      width: 100%;
      overflow-x: auto;
      padding: 10px 0;

      table {
        padding: 5px;
      width: 100%;
        border-collapse: collapse;

        tr {
          line-height: 30px;
        }

        .th {
          height: 30px;
          line-height: 30px;
          background-color: #f5f6f6;
          text-align: center;
        }

        td {
          padding:0 2px;
          line-height: 30px;
          border-bottom: 1px solid #f5f6f6;
          background-color: #fff;
          border-bottom: 1px solid #f5f6f6;
          border: 1px solid #eee; /* 设置单元格边框 */
        }

      
        .link-text {
          color: #0089ff;
        }
      }

      .van-button {
        margin: 0 10px;
      }
    }
  }
}

</style>